<!--

	Was macht diese Componente?
	Wofür ist die Compoente da?

	Welche $props gibt es?

	Beispiel Code:
		<CvIntro></CvIntro>

	2019-06-08	init

-->

<template>
	<div class="CvIntro maxWidth maxWidth--page" :class="elmClasses">
		<div class="CvIntro__inner">

			<div class="CvIntro__header background background--white">
				<h2 class="CvIntro__headerTitle hSpace hSpace--large font XXfont--bold font--sizeBig">
					CSV-Validator für ADAB-Metadaten
				</h2>
			</div>
			<div class="CvIntro__body background background--white hSpace hSpace--large">
				<p>
					Mit Hilfe des CSV-Validator des Landesamtes für Denkmalpflege können Sie Ihre ADAB-Metadaten.csv Datei validieren bzw. neu erstellen. Benutzen Sie dazu bitte die jeweils aktuellen Browserversionen von Google Chrome, Mozilla Firefox oder Microsoft Edge. Ältere Browser können unter Umständen Probleme bei der Darstellung der Inhalte haben. Eingeschaltetes JavaScript ist erforderlich.
				</p>


				<div v-show-slide="isTextExpanded">
					<br />

					<ul>
						<li>Als Feld-/Spaltentrenner ist das Semikolon (;) zu verwenden, als Dezimaltrenner (d. h. für die Trennung von Vor- und Nachkommastellen von Werten) wird der Punkt (.) verwendet.</li>
						<li>Für die korrekte Anzeige von Umlauten und gegebenenfalls Sonderzeichen achten Sie auf die Speicherung Ihrer CSV-Datei im Zeichensatzformat „UTF-8“.</li>
						<li>Dateien, die nicht korrekt in UTF-8 kodiert sind, werden nicht akzeptiert. Bitte verzichten Sie auf die Umschreibung von Umlauten.</li>
						<li>Stellen Sie bitte noch sicher, dass Ihre CSV-Dateien keine „Programmartefakte“ (beispielsweise Steuerzeichen aus/für Microsoft Excel) enthalten.</li>
					</ul>

					<br />

					<p>Zu keiner Zeit werden Ihre Daten auf unseren Servern gespeichert oder für andere Zwecke und/oder Teilnehmer zugänglich gemacht. Weitere Informationen zur Erhebung von Daten nach der Datenschutz-Grundverordnung können Sie hier entnehmen: <a href="https://rp.baden-wuerttemberg.de/Seiten/datenschutz.aspx" target="_blank">https://rp.baden-wuerttemberg.de/Seiten/datenschutz.aspx.</a></p>

					<br />
				</div>

				<br />

				<a class="block" @click="isTextExpanded = !isTextExpanded">
					<template v-if="isTextExpanded">Einklappen</template>
					<template v-else>Ausklappen</template>
				</a>
			</div>
			<div class="CvIntro__footer background background--grey hSpace hSpace--large">
				<!-- start with file upload  -->
				<div class="CvIntro__footerColumn CvIntro__footerColumn--uploadFile">
					<p class="font font--bold color color--white vSpace vSpace--default">
						Bestehende CSV-Datei hochladen:
					</p>
					<br />
					<!--
					<input
						type="file"
						@change="app.onSelectFile"
						multiple="false"
						accept=".csv"
					/>
					-->
					<BaseFileInput
						:label="'Wähle CSV-Datei ...'"
						:accept="'.csv'"
						@input="app.onSelectFile"
					></BaseFileInput>
				</div>

				<!-- oder -->
				<div class="CvIntro__footerColumn CvIntro__footerColumn--or">
					<div class="background background--lightGrey"></div>
					<div class="color color--lightGrey">oder</div>
					<div class="background background--lightGrey"></div>
				</div>

				<!-- start with new document -->
				<div class="CvIntro__footerColumn CvIntro__footerColumn--createFile" v-if="app.doc">
					<p class="font font--bold color color--white vSpace vSpace--default">
						Neue CSV-Datei anlegen:
					</p>
					<br />
					<BaseButton
						class="BaseButton--validate"
						tag="button"
						label="Weiter"
						@click.native="createNewDoc()"
					></BaseButton>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	//import BaseSelect from '@/components/MhForm/BaseSelect.vue'
	import BaseSelect from '@/components/MhForm/v1/BaseSelect.vue'
	import BaseButton from '@/components/MhForm/v1/BaseButton.vue'
	import BaseFileInput from '@/components/MhForm/v1/BaseFileInput.vue'

	export default {
		name: 'CvIntro',
		components: {
			BaseSelect,
			BaseButton,
			BaseFileInput,
		},
		mixins: [],
		props: {},
		data() {
			return {
				isTextExpanded : false,
			}
		},
		watch: {},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []

				//classes.push('new_class')

				return classes
			},
		},
		methods: {
			createNewDoc(){ // reset doc and goto EditView
				this.app.doc.resetData()
				this.$router.push({ name : 'EditView' })
			},
		},
		created() {},
		mounted() {},
		destroyed () {},
	}
</script>

<style lang="less">
	@import "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";

	.CvIntro {
		//outline: 1px solid green;

		display: flex;
		flex-direction: row;
		align-items: center;
		flex-grow: 1;
		width: 100%;
		margin: 0 auto;
	}
	.CvIntro__inner {}

	.CvIntro__header {
		padding: 1.5em 0;

		border-bottom: 1px solid @swatches[middleGrey];
		border-top-left-radius: 0.25em;
		border-top-right-radius: 0.25em;

		&Title {
			opacity: 0.5;
		}
	}
	.CvIntro__body {
		padding: 1.5em 0;

		//border-top-left-radius: 0.25em;
		//border-top-right-radius: 0.25em;
	}
	.CvIntro__footer {
		padding: 0.5em 0 1em;
		border-bottom-left-radius: 0.25em;
		border-bottom-right-radius: 0.25em;

		.grid;
		.grid--columnGap;
		grid-template-columns: 1fr 5em 1fr;

		&Column {
			//background-color: fade( red, 20 );
			padding: 0em 0;
			overflow: hidden;
		}
		&Column--uploadFile {
			padding-bottom: 2em;
		}
		&Column--createFile {
			padding-bottom: 2em;
		}
		&Column--or {
			display: flex;
			flex-direction: column;
			align-items: center;

			div:nth-child(1) { flex-grow: 1; width: 1px; }
			div:nth-child(2) { padding: 0.25em; }
			div:nth-child(3) { flex-grow: 1; width: 1px; }
		}
	}

	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
